import { eventChannel } from "redux-saga";
import { IConversationMessage } from "../../../types/webchatConversation";
import { addNewMessage } from "../../chat/actions";

// eslint-disable-next-line require-yield
export function* subscribe(socket) {
  return eventChannel((emit: any) => {
    socket.on("new-message", (message: IConversationMessage) => {
      return emit(addNewMessage(message));
    });

    return () => {
      // do nothing
    };
  });
}
